module.exports = __webpack_public_path__ + "img/camp_shirt_gk8.b1bea34e.svg";